import { Code2 } from "lucide-react";
import logo from "@/assets/logo.webp";
import { standorte } from "@/data/standorte";

export const Footer = () => {
  return (
    <footer className="border-t border-background/10 bg-foreground text-background">
      <div className="container mx-auto py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-12 gap-12 mb-12">
          <div className="lg:col-span-3">
            <img src={logo} alt="Malerfachbetrieb Stein" className="h-9 mb-6" width={140} height={36} loading="lazy" decoding="async" />
            <p className="text-sm text-background/80 font-light leading-relaxed">
              Malerfachbetrieb Stein GmbH und Co. KG<br />
              Ihr Malermeister in Herford
            </p>
          </div>

          <div className="lg:col-span-3">
            <h3 className="text-[11px] tracking-[0.2em] uppercase mb-6 font-medium text-background/70">Leistungen</h3>
            <ul className="space-y-2.5">
              {[
                { name: "Fassadensanierung & WDVS", link: "/fassadensanierung-wdvs-herford" },
                { name: "Innendämmung & Schimmelschutz", link: "/innendaemmung-schimmelschutz-herford" },
                { name: "Energetische Sanierung", link: "/energetische-sanierung-herford" },
                { name: "Malerarbeiten & Innensanierung", link: "/innensanierung-malerarbeiten-herford" },
                { name: "Badrenovierung & Fugenlos", link: "/badrenovierung-fugenlose-baeder-herford" },
                { name: "Edle Oberflächen & Böden", link: "/edle-oberflaechen-designboeden-herford" },
              ].map((item) => (
                <li key={item.name}>
                  <a href={item.link} className="text-sm text-background/80 hover:text-background transition-colors font-light">
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h3 className="text-[11px] tracking-[0.2em] uppercase mb-6 font-medium text-background/70">Unternehmen</h3>
            <ul className="space-y-2.5">
              {[
                { name: "Über uns", link: "/ueber-uns" },
                { name: "Referenzen", link: "/#referenzen" },
                { name: "Kontakt", link: "/#kontakt" }
              ].map((item) => (
                <li key={item.name}>
                  <a href={item.link} className="text-sm text-background/80 hover:text-background transition-colors font-light">
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h3 className="text-[11px] tracking-[0.2em] uppercase mb-6 font-medium text-background/70">Kontakt</h3>
            <ul className="space-y-2.5 text-sm text-background/80 font-light">
              <li className="font-medium text-background">Malerfachbetrieb Stein GmbH und Co. KG</li>
              <li><a href="tel:+4952213832130" className="hover:text-background transition-colors">05221 / 3832130</a></li>
              <li><a href="tel:+491788783369" className="hover:text-background transition-colors">0178 / 8783369</a></li>
              <li><a href="mailto:info@malerfachbetrieb-stein.de" className="hover:text-background transition-colors break-all">info@malerfachbetrieb-stein.de</a></li>
              <li className="pt-2">
                Mindener Str. 183<br />
                32049 Herford
              </li>
            </ul>
          </div>
        </div>

        <div className="mb-12 pt-8 border-t border-background/10">
          <h3 className="text-[11px] tracking-[0.2em] uppercase mb-6 font-medium text-background/70">Standorte</h3>
          <div className="flex flex-wrap gap-x-5 gap-y-2">
            {standorte.map((s) => (
              <a
                key={s.slug}
                href={`/maler-${s.slug}`}
                className="text-sm text-background/80 hover:text-background transition-colors font-light"
              >
                Maler {s.city}
              </a>
            ))}
          </div>
        </div>

        <div className="pt-8 border-t border-background/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 mb-3">
            <div className="flex gap-6">
              <a href="/impressum" className="text-xs text-background/80 hover:text-background transition-colors font-light">
                Impressum
              </a>
              <a href="/datenschutz" className="text-xs text-background/80 hover:text-background transition-colors font-light">
                Datenschutz
              </a>
            </div>
            <p className="text-xs text-background/80 font-light">
              © 2025 Malerfachbetrieb Stein GmbH. Alle Rechte vorbehalten.
            </p>
            <div className="md:w-32"></div>
          </div>
          <p className="text-xs text-background/80 font-light text-center">
            Eine <a href="https://webtrieb.de" target="_blank" rel="noopener noreferrer" className="hover:text-background transition-colors font-bold text-orange-500 inline-flex items-center gap-1"><Code2 className="w-3.5 h-3.5" />Webtrieb</a> Webseite
          </p>
        </div>
      </div>
    </footer>
  );
};
